import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useUserRights } from "../../../contexts/UserRightsContext";
import { dateFormatter } from "../../fomatters/DateFormatter";
import Crud from "../Crud";

function PlayersOnCall() {
  const crudRef = useRef(null);
  const history = useHistory();
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [refreshInterval, setRefreshInterval] = useState(5);
  const [menu, setMenu] = useState({ visible: false, x: 0, y: 0, row: null });

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  // Cierra el menú al hacer click en cualquier parte
  useEffect(() => {
    if (!menu.visible) return;
    const close = () => setMenu((m) => ({ ...m, visible: false }));
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [menu.visible]);

  const openMenu = (e, row) => {
    e.preventDefault();
    e.stopPropagation();
    setMenu({ visible: true, x: e.clientX, y: e.clientY, row });
  };

  const closeMenu = () => setMenu((m) => ({ ...m, visible: false }));

  const handleIntervalChange = (e) => setRefreshInterval(e.target.value);

  const ReleaseAll = () => {
    const url = `${process.env.REACT_APP_API2_URL}/Player/ClientPlayerLogoutAll`;
    axios.get(url)
      .then(() => {
        toast.success("Released");
        crudRef.current?.requestData();
      })
      .catch(() => toast.error("Error"));
  };

  const Release = (row) => {
    if (!row) return;
    axios.post(`${process.env.REACT_APP_API2_URL}/Player/ClientPlayerLogout`, {
      IdPlayer: row.idPlayer,
      System: row.system,
      IdCall: row.idCall,
      IdUser: userInfo?.userId,
    })
      .then(() => {
        toast.success("Released");
        crudRef.current?.requestData();
      })
      .catch(() => toast.error("Error"));
  };

  const Info = (row) => {
    if (row?.idPlayer) history.push(`/player/${row.idPlayer}`);
  };

  const systemFormatter = (value) => {
    const map = { M: "Manager", N: "Lines Manager", L: "Call Center", R: "Racing Client", B: "Bet Ticker", I: "Web Client", J: "Don Best Game Importer" };
    return map[value] ?? value;
  };

  const row = menu.row;

  return (
    <div className="flex flex-col gap-4 h-max">

      {/* Menú contextual custom */}
      {menu.visible && (
        <div
          style={{ position: "fixed", top: menu.y, left: menu.x, zIndex: 9999, background: "#fff", border: "1px solid #ccc", boxShadow: "2px 2px 5px rgba(0,0,0,.15)", padding: "4px 0", minWidth: 140 }}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="react-contextmenu-item" onMouseDown={() => { closeMenu(); Info(row); }}>
            Player Info
          </div>
          <div
            className={`react-contextmenu-item${!hasRights(545) ? " react-contextmenu-item--disabled" : ""}`}
            onMouseDown={hasRights(545) ? () => { closeMenu(); Release(row); } : undefined}
          >
            Release
          </div>
          <div
            className={`react-contextmenu-item${!hasRights(476) ? " react-contextmenu-item--disabled" : ""}`}
            onMouseDown={hasRights(476) ? () => { closeMenu(); ReleaseAll(); } : undefined}
          >
            Release All
          </div>
          <div className="react-contextmenu-item" onMouseDown={() => { closeMenu(); crudRef.current?.requestData(); }}>
            Refresh
          </div>
        </div>
      )}

      <Crud
        ref={crudRef}
        interval={refreshInterval * 1000}
        title="Players On Call"
        getUrl={({ userId }) => `/Player/PlayersOnline_List?idUser=${userId}`}
        onRequestData={() => {}}
      >
        <TableHeaderColumn hidden isKey dataField="logonSessionID">
          LogonSessionID
        </TableHeaderColumn>
        <TableHeaderColumn hidden dataField="idPlayer">
          IdPlayer
        </TableHeaderColumn>
        <TableHeaderColumn
          filter={{ type: "TextFilter", delay: 1000 }}
          dataField="player"
          dataSort
          dataFormat={(cell, row) => (
            <span className="context-cell" onContextMenu={(e) => openMenu(e, row)}>
              {cell}
            </span>
          )}
        >
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataField="placedDate" dataFormat={dateFormatter} dataSort>
          Login Time
        </TableHeaderColumn>
        <TableHeaderColumn dataField="loginName" dataSort>
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataField="phoneLine" dataSort>
          Phone Line
        </TableHeaderColumn>
        <TableHeaderColumn dataField="system" dataSort dataFormat={systemFormatter}>
          System
        </TableHeaderColumn>
        <TableHeaderColumn dataField="ip" dataSort>
          IP
        </TableHeaderColumn>
        <TableHeaderColumn dataField="idCall" dataSort>
          Call ID
        </TableHeaderColumn>
      </Crud>

      <div className="flex items-center gap-2">
        <label>Refresh every:</label>
        <input type="number" value={refreshInterval} onChange={handleIntervalChange} className="p-1 border rounded" min="1" />
        <span>seconds</span>
      </div>
    </div>
  );
}

export default PlayersOnCall;
